<template>
  <div class="cpt-room-container relative w-full pt-[12px] flex-col-items-center">
    <!-- 当前房间未在房间列表缓存中，作为临时房间展示 -->
    <div ref="cur-room-temp" v-if="isShowCurRoomTemp" class="temp-room"></div>
    <div ref="invite-temp" v-if="isShowInviteTemp" class="temp-room"></div>

    <div 
      v-if="usedFolderSort"
      class="room-sort-btn flex h-[24px] pointer justify-center items-center gap-[3px] opacity-95 px-0 py-[13px] mb-[6px] rounded-[12px]"
      :class="[
        sortBtnActive ? 'text-bd-tx' : 'text-op-4',
        isCurRoomTemp || isInviteTemp ? 'mt-[6px]' : ''
      ]"
      ref="roomSortPopoverTrigger"
      v-report.click="{
        event_type: 'room_sort_btn',
      }"
    >
      <i class="iconfont icon-sort"></i>
      <span class="text-center text-[12px] font-bold">排序</span>
    </div>

    <Popover 
      key="room-sort-popover" 
      ref="room-sort-popover" 
      :triggerType="'click'" 
      :triggerRef="roomSortPopoverTrigger"
      @updateShow="handleOpenSort"
      class="room-sort-setting-popover" 
      :hideDelay="300"
      autoPos="right bottom"
      :offset="{
        x: 200,
        y: 80,
      }"
    >
      <div 
        class="room-sort-setting-container flex w-[188px] flex-col items-start shadow-[0px_3px_15px_0px_rgba(0,0,0,0.35)] bg-fl-pp px-[8px] py-[8px] rounded-[8px]"
      >
        <div class="room-sort-setting-item" 
          v-for="(item, index) in roomSortSettingConfig" 
          :key="index"
          :class="{
            active: folderSort === item.value
          }"
          v-report.click="{
            event_type: 'room_sort_item',
            addition: {
              sort: item.value
            },
          }"
          @click="handleChangeSort(item.value)"
        >
          <div class="room-sort-setting-item-label">{{ item.label }}</div>
          <div class="radio"></div>
        </div>
      </div>
    </Popover>
    <div class="w-full" ref="rooms" v-delegate="delegateEvents"></div>
  </div>
</template>

<script>
import { setStorage, throttle, deepCopy } from "_lib/utils/utils";
import { mapGetters, mapMutations, mapActions } from "vuex";
import EventBus from "@/common/EventBus";
import Cache from "_lib/DataCache";
const Popover = () => import("_com/func/Popover.vue");
import {
  getSideFolders,
  createRoomFolder,
  sortSideFolders,
} from "_api/room/index";
import { enterRoom } from "_api/ws.js";
import { getChannelInviteCode } from "_api/invite";
import { getWsId } from "_api/account";
import { applyJoinRoom } from "_api/channel";
import { ENTER_BY_INVITE_CODE_TYPES, FOLDER_SORT_MODE } from "@/common/constants/room";
import { handleEnterRoom } from "_lib/EnterRoom";
import { calRoomShortCutHeihgt } from "_lib/utils/utilsRoom.js";
import { NOTICE_TYPE_TEXT } from "@/common/constants/message";
import { CHANNEL_TYPES, CHANNEL_USER_UPDATE_MOVE_TYPE } from '_lib/constants/channel';
import { updateAccountSetting } from "_api/settings";
import { calcUserName } from "_lib/CalcUserInfo";

const VIRTUAL_ROOMSHORTCUTS_SCROLLER_CONFIG = {
  USE_VIRTUAL_LIMIE: 40,
  DEFAULT_SIZE: 40,
  TOP_THRESHOLD: 100,
  BOTTOM_THRESHOLD: 100,
};

// 左上语音首页跳转图标高度
const CHAT_ICON_HEIGHT = 54;
import RoomItemRenderInstance from "./components/roomItemRender.js";
import FolderRenderCtr from './components/folderItemRender.js'
import UpdateHandler from './components/updateHandler.js'
import eventsMixin from './eventsMixin.js'
import contextMenuMixin from "../../mixin/shortCutsContextMenu.js";
import updateHandler from "./components/updateHandler.js";
export default {
  name: "",
  mixins: [eventsMixin, contextMenuMixin],
  components: {
    Popover,
  },
  props: {
    isCompleted: {
      default: null,
      type: Array
    }
  },
  data() {
    return {
      folders: [],
      sessions: [],
      open_folders: {},
      show_folders_index: [
        0,
        0 + VIRTUAL_ROOMSHORTCUTS_SCROLLER_CONFIG.DEFAULT_SIZE,
      ],
      scrollerOffsetTop: 0,
      showDownloadClientDialog: true,
      showCreateRoomIcon: true,
      resizeObserver: null,

      sortBtnActive: false,
      FOLDER_SORT_MODE,
      roomSortSettingConfig: [
        {
          label: '默认排序',
          value: FOLDER_SORT_MODE.DEFAULT,
        },
        {
          label: '最常访问',
          value: FOLDER_SORT_MODE.MOST_VISITED,
        },
        {
          label: '最近访问',
          value: FOLDER_SORT_MODE.RECENTLY_VISITED,
        },
      ],
      roomSortPopoverTrigger: null,
      isShowCurRoomTemp: '',
      isShowInviteTemp: '',
      folderInstances: new Map(),
      delegateEvents: {
        click: {
          'click-room': {
            handler: this.handleClickRoom,
          },
          'click-folder': {
            handler: this.handleClickFolder,
          }
        },
        contextmenu: {
          'ctxmenu-room': {
            handler: this.handleCtxmenuRoom,
          },
          'ctxmenu-folder': {
            handler: this.handleCtxmenuFolder,
          }
        },
        dragstart: {
          'dragstart-room': {
            handler: this.handleDragstartRoom,
          },
          'dragstart-folder': {
            handler: this.handleDragstartFolder,
          }
        },
        dragenter: {
          'dragenter-room': {
            handler: this.handleDragenterRoom,
          },
          'dragenter-folder': {
            handler: this.handleDragenterFolder,
          }
        },
        dragover: {
          'dragover-room': {
            handler: this.handleDragoverRoom,
          },
          'dragover-folder': {
            handler: this.handleDragoverFolder,
          }
        },
        dragleave: {
          'dragleave-room': {
            handler: this.handleDragleaveRoom,
          },
          'dragleave-folder': {
            handler: this.handleDragleaveFolder,
          }
        },
        drop: {
          'drop-room': {
            handler: this.handleDropRoom,
          },
          'drop-folder': {
            handler: this.handleDropFolder,
          }
        }
      }
    };
  },
  watch: {
    isCompleted() {
      this.updateScrollerOffsetTop()
    },
    usedFolderSort(v) {
      if(v) {
        this.$nextTick(() => {
          this.initTrigger()
        })
      }
    },
    isCurRoomTemp (val) {
      this.renderCurRoomTemp(val)
    },
    isInviteTemp (val) {
      this.renderInviteTemp(val)
    },
    cur_room_data (val, oldVal) {
      UpdateHandler.updateActiveRoom(val.room_id, oldVal.room_id)
    }
  },
  computed: {
    ...mapGetters([
      "user_info",
      "room_list",
      "cur_room_data",
      "cur_channel_data",
      "channel_data",
      "ws_id",
      "temp_private_invite",
      "api_poll_interval",
      "show_theme_data",
      "bar_theme",
      "cur_room_whole_data",
      "discover_enter_way",
      'user_account_settings',
    ]),
    curRoom() {
      const { room_id } = this.$route.params;
      for (let r of this.$route.matched) {
        if (r.name == "room") {
          return room_id;
        }
      }
    },
    isCurRoomTemp() {
      let isCurRoomTemp = false;
      if (
        this.cur_room_data &&
        this.cur_room_data.room_id &&
        this.cur_room_data.room_name &&
        !this.room_list.find(
          (item) => item.room_id === this.cur_room_data.room_id
        )
      ) {
        isCurRoomTemp = true;
      }
      return isCurRoomTemp;
    },
    isInviteTemp() {
      if (this.temp_private_invite) {
        if (this.isCurRoomTemp) {
          return (
            this.temp_private_invite.room_id !== this.cur_room_data.room_id
          );
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isVirtualRoomList() {
      return (
        this.folders.length >
        VIRTUAL_ROOMSHORTCUTS_SCROLLER_CONFIG.USE_VIRTUAL_LIMIE
      );
    },
    usedFolderSort() {
      const LIMIT_COUNT = 9
      return this.user_account_settings?.folder_sort !== undefined || this.flattenRoomList.length > LIMIT_COUNT
    },
    folderSort() {
      if(this.usedFolderSort) {
        return this.user_account_settings?.folder_sort ?? FOLDER_SORT_MODE.DEFAULT
      } else {
        return FOLDER_SORT_MODE.DEFAULT
      }
    },
    // 排序过后的扁平话房间列表
    flattenRoomList() {
      return this.folders.reduce((acc, folder, folderIndex) => {
          const { rooms } = folder
          acc.push(...rooms.map(room => ({ ...room, folderIndex })))
          return acc
        }, [])
    },
    canDragRoom() {
      return this.folderSort === FOLDER_SORT_MODE.DEFAULT
    },
    showFlattenRoomList() {
      if(this.folderSort === FOLDER_SORT_MODE.DEFAULT) {
        return []
      } else {
        // 使用房间列表排序的情况
        const list = this.folders.reduce((acc, folder, folderIndex) => {
          const { rooms } = folder
          acc.push(...rooms.map(room => ({ ...room, folderIndex })))
          return acc
        }, []).sort((a, b) => {
          // 如果该房间之前未出现在folders列表里面，是一个新增的房间数据
          // visit_at默认值为Date.now()
          // visit_count默认值为0
          const { visit_at: aVisitAt = Date.now(), visit_count: aVisitCount = 0, room_id: aRoomId } = a
          const { visit_at: bVisitAt = Date.now(), visit_count: bVisitCount = 0, room_id: bRoomId } = b
          if (this.folderSort === FOLDER_SORT_MODE.MOST_VISITED) {
            // 按visit_count从高到低排序
            if(aVisitCount === bVisitCount) {
              return bVisitAt - aVisitAt
            } else {
              return bVisitCount - aVisitCount
            }
          } else {
            // 如果当前房间是a，则a排在b前面
            if(aRoomId === this.cur_room_data.room_id) {
              return -1
            } else if (bRoomId === this.cur_room_data.room_id) {
              return 1
            } else {
              // 按visit_at从高到低排序
              return bVisitAt - aVisitAt
            }
          }
        })
        return list
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    EventBus.$on("Join_Room_Or_Channel", this.jumpRoomChannel);
    EventBus.$on("Message_Update_Room", this.getSideFolders);
    // 房间内语音频道成员更新
    EventBus.$on('SOCKET_CHANNEL_USER_UPDATE', this.updateRoomMembers);

    // 更新房间的状态人数（当前用户 语音，伴奏，屏幕共享）
    EventBus.$on("Add_Room_State_Number", this.addRoomStateNumber);

    // ws重连更新
    EventBus.$on("Socket_Connect", this.getSideFolders);
    // 处理房间被删除
    EventBus.$on("SOCKET_ROOM_OR_CHANNEL_DELETE", this.handleRoomDelete);
    // 左侧房间列表删除房间
    EventBus.$on("SOCKET_ROOM_LIST_DEL_ITEM", this.delRoomFromList);
    // 更新房间信息
    EventBus.$on("SOCKET_UPDATE_ROOM_INFO", this.handleUpdateRoomInfo);
    // 更新房间列表
    EventBus.$on("SOCKET_ROOM_LIST_UPDATE", this.handleUpdateRoomList);

    // 房间置顶
    EventBus.$on("Set_Room_Top", this.setRoomTop);
    // 获取邀请码监听
    EventBus.$on("Get_Invite_Code", this.getInviteCode);
    // 通过public_id加入房间并刷新房间列表
    EventBus.$on("Join_Public_Room", this.joinPublicRoom);

    // 进入默认房间
    EventBus.$on("Enter_Default_Room", this.enterDefaultRoom);
    // 更新房间文件夹数据
    EventBus.$on("Update_Folder_Data", this.updateFolderData);

    // 左侧小程序列表添加 会影响列表展示的距离判断
    EventBus.$on("MiniProgram_Add", this.updateScrollerOffsetTop);
    // 左侧小程序列表删除 会影响列表展示的距离判断
    EventBus.$on("MiniProgram_Delete", this.updateScrollerOffsetTop);
    // 左侧小程序列表文件夹折叠删除 会影响列表展示的距离判断
    EventBus.$on("MiniProgramFolder:changeIsOpen", this.updateScrollerOffsetTop);
    // 左侧小程序列表文件夹排序，可能有小程序被拖拽到文件夹 会影响列表展示的距离判断
    EventBus.$on("MiniProgramFolder:sort", this.updateScrollerOffsetTop);

    // 修改火花
    EventBus.$on("Update_Hide_Room_Fire_Flag", this.updateHideRoomFireFlag)
    EventBus.$on("Update_Fire_Flag", this.updateFireFlag)
    EventBus.$on('UpdateRoomUnreadRedPoint', this.updateUnreadStateCache)
    EventBus.$on('User_Account_Settings_Inited', this.onUserAccountSettingsInit)

    this.$parent.$refs["shortcuts-scroller"].addEventListener("scroll", this.handleShortCutsScroll);
    window.addEventListener('resize', this.handleWindowResize)

    this.$nextTick(() => {
      this.initTrigger();
    })
  },
  beforeDestroy() {
    EventBus.$off('SOCKET_CHANNEL_USER_UPDATE', this.updateRoomMembers);
    EventBus.$off("Join_Room_Or_Channel", this.jumpRoomChannel);
    EventBus.$off("Message_Update_Room", this.getSideFolders);
    EventBus.$off("Add_Room_State_Number", this.addRoomStateNumber);
    EventBus.$off("Socket_Connect", this.getSideFolders);
    EventBus.$off("SOCKET_ROOM_OR_CHANNEL_DELETE", this.handleRoomDelete);
    EventBus.$off("SOCKET_UPDATE_ROOM_INFO", this.handleUpdateRoomInfo);
    EventBus.$off("Set_Room_Top", this.setRoomTop);
    EventBus.$off("Get_Invite_Code", this.getInviteCode);
    EventBus.$off("Join_Public_Room", this.joinPublicRoom);
    EventBus.$off("SOCKET_ROOM_LIST_DEL_ITEM", this.delRoomFromList);
    EventBus.$off("Enter_Default_Room", this.enterDefaultRoom);
    EventBus.$off("Update_Folder_Data", this.updateFolderData);
    EventBus.$off("SOCKET_ROOM_LIST_UPDATE", this.handleUpdateRoomList);
    EventBus.$off("MiniProgram_Add", this.updateScrollerOffsetTop);
    EventBus.$off("MiniProgram_Delete", this.updateScrollerOffsetTop);
    EventBus.$off(
      "MiniProgramFolder:changeIsOpen",
      this.updateScrollerOffsetTop
    );
    EventBus.$off("MiniProgramFolder:sort", this.updateScrollerOffsetTop);
    EventBus.$off("Update_Hide_Room_Fire_Flag", this.updateHideRoomFireFlag)
    EventBus.$off("Update_Fire_Flag", this.updateFireFlag)
    EventBus.$off('UpdateRoomUnreadRedPoint', this.updateUnreadStateCache)
    EventBus.$off('User_Account_Settings_Inited', this.onUserAccountSettingsInit)

    this.$parent.$refs["shortcuts-scroller"].removeEventListener("scroll", this.handleShortCutsScroll);
    window.removeEventListener("resize", this.handleWindowResize)
  },
  methods: {
    renderCurRoomTemp(val) {
      const props = {
        room: this.cur_room_data,
        temp_type: 'public',
        isTemp: true,
        draggable: false
      }
      if (val) {
        this.isShowCurRoomTemp = this.cur_room_data.room_id
        this.$nextTick(() => {
          this.$refs['cur-room-temp'].innerHTML = RoomItemRenderInstance.render(props)
          RoomItemRenderInstance.initEvents(props)
        })
      } else {
        props.room = {
          room_id: this.isShowCurRoomTemp,
        }
        RoomItemRenderInstance.destroy(props)
        this.isShowCurRoomTemp = ''
      }
    },
    renderInviteTemp(val) {
      const props = {
        room: this.temp_private_invite.room,
        temp_type: 'invite',
        draggable: false,
        isTemp: true,
      }
      if (val) {
        this.isShowInviteTemp = this.temp_private_invite.room.room_id
        this.$nextTick(() => {
          this.$refs['invite-temp'].innerHTML = RoomItemRenderInstance.render(props)
          RoomItemRenderInstance.initEvents(props)
        })
      } else {
        props.room = {
          room_id: this.isShowInviteTemp,
        }
        RoomItemRenderInstance.destroy(props)
        this.isShowInviteTemp = ''
      }
    },
    renderFolderList () {
      let html = ''
      this.folderInstances = new Map()
      this.roomInstances = []
      if (this.folderSort === FOLDER_SORT_MODE.DEFAULT) {
        this.folders.forEach((folder, index) => {
          if (folder.folder_id && folder.folder_id != '0') { 
            const folderRenderInstance = new FolderRenderCtr({
              data: folder,
              isDefaultOpen: this.open_folders[folder.folder_id],
              draggable: this.canDragRoom
            })
            this.folderInstances.set(folder.folder_id, folderRenderInstance)
            html += folderRenderInstance.render({index: index})
          } else {
            html += RoomItemRenderInstance.render({
              room: folder.rooms[0],
              index: index,
              draggable: this.canDragRoom
            })
            this.roomInstances.push(folder.rooms[0])
          }
        })
      } else {
        this.showFlattenRoomList.forEach(room => {
          html += RoomItemRenderInstance.render({
            room: room,
            index: room.folderIndex,
            draggable: this.canDragRoom
          })
          this.roomInstances.push(room)
        })
      }
      this.$refs['rooms'].innerHTML = html
      for (let folder of this.folderInstances.values()) {
        folder.initEvents()
      }
      for (let room of this.roomInstances) {
        RoomItemRenderInstance.initEvents({
          room: room,
        })
      }
    },
    updateHideRoomFireFlag(room, value) {
      const roomId = room.room_id
      for(const fold of this.folders) {
        if(fold.folder_id == 0) {
          if(fold.rooms[0].room_id === roomId) fold.rooms[0].hide_room_fire_flag = value
        } else {
          const room = fold.rooms.find(room => room.room_id === roomId)
          if(room) room.hide_room_fire_flag = value
        }
      }
    },
    updateFireFlag(room) {
      const roomId = room.room_id
      for(const fold of this.folders) {
        if(fold.folder_id == 0) {
          if(fold.rooms[0].room_id === roomId) fold.rooms[0].is_public = room.is_public
        } else {
          const info = fold.rooms.find(room => room.room_id === roomId)
          if(info) info.is_public = info.is_public
        }
      }
    },
    onUserAccountSettingsInit () {
      this._is_account_setting_inited = true
      if (!this._is_render_folder_list) {
        this.renderFolderList()
      }
    },
    async init() {
      await this.getSideFolders();
      this.$emit("getFolderDone", true);
      if (this._is_account_setting_inited) {
        this._is_render_folder_list = true
        this.renderFolderList()
      }
    },
    // 获取房间列表
    async getSideFolders() {
      const res = await getSideFolders({
        room_type: 4,
        _notip: true,
      });
      if (res.data.status == "ok") {
        const folders = res.data.result.folders.map((folder) => {
          folder.domHeight = calRoomShortCutHeihgt(
            folder.folder_id === 0 ? "room" : "folder",
            folder.rooms.length,
            this.open_folders[folder.folder_id]
          );
          return folder;
        });
        if (this.folders.length) {
          const changed = this.compareFolderChanges(
            this.folders,
            folders
          );
          this.handleChangedFolders(changed)
        }
        this.folders = folders
        let _room_list = [];
        this.folders.forEach((v) => {
          if (v.rooms) {
            v.rooms.forEach((room) => {
              room.folder_id = v.folder_id;
            });
            _room_list = [..._room_list, ...v.rooms];
          }
          if ((!v.folder_id || v.folder_id === '0') && v.rooms[0]) {
            updateHandler.updateRoomAudioIcon(v.rooms[0])
          }
        });
        this.SET_ROOM_LIST(_room_list);

        if (this.getRoomListTimer) clearTimeout(this.getRoomListTimer);
        let interval = this.api_poll_interval("folders", 60 * 2);
        this.getRoomListTimer = setTimeout(() => {
          this.getSideFolders(null);
        }, interval * 1000);
        this.$emit("getFolderDone");
        this.handleShortCutsScroll();
        this.$nextTick(() => {
          this.initTrigger()
        })
        return true;
      } else if (res.data.status === "relogin") {
        this.$emit("getFolderDone");
        return;
      }
      return false;
    },
    async jumpRoomChannel(v, type, paramsData) {
      this.getSideFolders();
      if (
        !(
          this.$route.name === "room" && this.$route.params.room_id == v.room_id
        )
      ) {
        this.enterRoom(v, paramsData);
      }
    },
    async enterRoom(v, paramsData = {}) {
      if(this._enterRoomLock) return
      this._enterRoomLock = true
      if (!this.ws_id) {
        await getWsId().finally(() => {
          this._enterRoomLock = false
        });
      }
      const cache_data = await Cache.getRoomCache(v.room_id).finally(() => {
        this._enterRoomLock = false
      });
      let params = {
        room_id: v.room_id,
        ws_id: this.ws_id,
        // 大型房间不读取缓存，每次进入房间都重新获取数据
        room_data_cached: Boolean(cache_data && !cache_data?.room?.room_setting?.is_big),
        _notip: true,
      }
      if (this.cur_channel_data.room_id === params.room_id) {
        params.cur_channel_id = this.cur_channel_data.channel_id
      }
      const res = await enterRoom(params).finally(() => {
        this._enterRoomLock = false
      });
      if (res.data.status == "ok") {
        if (v.channel_id) {
          setStorage("await_enter_channel", {
            channel_id: v.channel_id,
            only_text: v.only_text,
          });
          v.channel_id = "";
        }
        const toData = {
          name: "room",
          params: {
            room_id: v.room_id,
            room_view_data: res.data.result.view,
            is_guidance: v.is_guidance,
            ...paramsData,
          }
        }
        if(this.$route.name === 'invite') {
          this.$router.replace(toData);
        } else {
          this.$router.push(toData);
        }
        this.SET_ENTER_DEFAULT_CHANNEL_RESULT(res.data.result.enter_channel);
        const room_data = res.data.result.view && res.data.result.view.room;
        const my_room_info =
          res.data.result.view && res.data.result.view.my_room_info;
        if (my_room_info && my_room_info.toast_notify_changed) {
          this.$query({
            config: {
              title: `${room_data.room_name} 通知方式由 ${NOTICE_TYPE_TEXT[String(room_data.last_room_notify_type)]
                } 修改为 ${NOTICE_TYPE_TEXT[String(room_data.room_notify_type)]}`,
              confirm: {
                text: "我知道了",
              },
              cancel: {
                text: "设置",
              },
            },
            cancelCB: () => {
              EventBus.$dynamic("NoticeConfig", {
                room_id: room_data.room_id,
                room_name: room_data.room_name,
              });
            },
          });
        }
      } else {
        if (res.data.result === "show_apply") {
          if (v.nickname && v.user_id) {
            this.$query({
              config: {
                title: `暂无该房间权限，是否向${calcUserName(v)}申请加入？`,
                confirm: {
                  text: "申请加入",
                },
                cancel: {
                  text: "忽略",
                },
              },
              confirmCB: () => {
                applyJoinRoom(
                  {},
                  {
                    room_id: v.room_id,
                    channel_id: v.channel_id,
                    to_user_id: v.user_id,
                  }
                ).then((res) => {
                  if (res.data.result === "ok") {
                    this.$toast.success("申请成功");
                  }
                });
              },
            });
            return;
          }
        }
        if (res.data.msg == "房间已删除") {
          this.sessions = this.sessions.filter((s) => s.room_id !== v.room_id);
          this.$forceUpdate();
        }
        if (!['redirect_room', 'block_room'].includes(res.data.status)) {
          this.$toast.error(res.data.msg);
        }
        if(res.data.status !== 'block_room') {
          this.$router.push({ name: "home" });
        }
      }
    },
    updateRoomMembers(data) {
      // move_type - 0: 加入; 1: 退出;
      let d = data.data, move_type = d.move_type
      const room_id = d.room_id
      const member = d.member
      if (!member) return
      if (move_type === CHANNEL_USER_UPDATE_MOVE_TYPE.JOIN) {
        this.addRoomStateNumber(room_id, "audio", 1, member)
      } else if (move_type === CHANNEL_USER_UPDATE_MOVE_TYPE.LEAVE) {
        this.addRoomStateNumber(room_id, "audio", 0, member)
      }
    },
    // 拖拽房间移动方法
    moveFolder(cur_ids, origin_ids, dragDirection, isSameFolder = false) {
      // ===== 第一步：定位和提取源元素信息 =====
      let {
        out_index: origin_out_index,
        out_item: origin_out_item,
        in_index: origin_in_index,
        in_item: origin_in_item,
      } = this.findFolderItem(origin_ids);

      // 确定被移动的元素（房间或文件夹）并准备数据
      let origin_folder = origin_out_item;
      let origin_room = origin_in_item || (origin_out_item.rooms && origin_out_item.rooms[0]) || origin_out_item;
      
      // 判断各种情况的标志
      const isFolder = origin_out_item.folder_id && origin_out_item.folder_id !== '0' && !origin_in_item;
      const isFromFolder = origin_in_item && origin_out_item.folder_id && origin_out_item.folder_id !== '0';
      
      // ===== 第二步：从数据结构中删除源元素 =====
      if (origin_in_item) {
        // 是文件夹内房间 - 从文件夹中移除此房间
        origin_out_item.rooms.splice(origin_in_index, 1);
        const folderInstance = this.folderInstances.get(origin_out_item.folder_id);
        folderInstance?.updateFolderNameTooltip(origin_out_item);
        // 创建包含单个房间的临时文件夹对象（用于外层插入）
        origin_folder = {
          folder_id: "0",
          folder_name: "",
          rooms: [origin_in_item],
        };
      } else {
        // 是文件夹或外层房间 - 从顶层列表中移除
        this.folders.splice(origin_out_index, 1);
      }

      // ===== 第三步：定位目标位置并插入数据 =====
      let {
        out_index: cur_out_index,
        out_item: cur_out_item,
        in_index: cur_in_index,
        in_item: cur_in_item,
      } = this.findFolderItem(cur_ids);
      // 判断目标是否为文件夹
      const isToFolder = cur_out_item && cur_out_item.folder_id && cur_out_item.folder_id !== '0';
      
      // 根据拖拽方向计算插入偏移量（上方为0，下方为1）
      let posAdd = dragDirection === "down" ? 1 : 0;
      
      // 将元素添加到数据结构中的目标位置
      if (cur_in_item) {
        // 目标是文件夹内房间位置 - 插入到此房间前/后
        cur_out_item.rooms.splice(cur_in_index + posAdd, 0, origin_room);
        const folderInstance = this.folderInstances.get(cur_out_item.folder_id);
        folderInstance?.updateFolderNameTooltip(cur_out_item);
      } else {
        // 目标是文件夹或外层房间位置 - 插入到顶层列表中
        this.folders.splice(cur_out_index + posAdd, 0, origin_folder);
      }
      
      // ===== 第四步：DOM操作 - 移除旧元素 =====
      // 将旧的DOM删除并更新相关文件夹高度
      this.removeSourceDom(origin_out_item, origin_room, isFolder, isFromFolder);
      
      // ===== 第五步：DOM操作 - 创建和插入新元素 =====
      // 创建新元素的HTML
      let insertHtml = this.createElementHtml(origin_out_item, origin_room, isFolder, cur_out_index);

      // 根据目标位置插入到对应位置
      if (cur_in_item) {
        // 插入到文件夹内部
        this.insertIntoFolder(cur_out_item, cur_in_index, posAdd, insertHtml, origin_room, isFolder);
      } else {
        // 插入到顶层列表
        this.insertIntoTopLevel(origin_folder, insertHtml, isFolder, origin_out_item, origin_room);
      }
      
      // ===== 第六步：更新文件夹头像和状态 =====
      // 如果源是展开的文件夹中的房间，更新源文件夹头像显示
      if (isFromFolder && this.folderInstances.get(origin_out_item.folder_id)) {
        this.updateFolderAvatars(origin_out_item);
      }
      
      // 如果目标是未展开的文件夹，更新目标文件夹头像显示
      if (isToFolder && cur_out_item && !this.isFolderOpen(cur_out_item.folder_id)) {
        this.updateFolderAvatars(cur_out_item);
      }
      
      // ===== 第七步：发送排序数据到服务器 =====
      this.sendFolderSort();
    },

    // 移除源元素DOM并处理相关元素
    removeSourceDom(origin_out_item, origin_room, isFolder, isFromFolder) {
      let oldEl = null;
      if (isFolder) {
        // 处理整个文件夹的移除
        oldEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${origin_out_item.folder_id}"]`);
        if (oldEl) {
          // 销毁文件夹实例并移除DOM
          const folderInstance = this.folderInstances.get(origin_out_item.folder_id);
          if (folderInstance) {
            folderInstance.destroy({room_id: origin_out_item.folder_id});
          }
          oldEl.remove();
        }
      } else if (origin_room) {
        // 处理单个房间的移除
        const selector = `.cpt-shortcut-block-wrapper[data-room-id="${origin_room.room_id}"]`;
        oldEl = this.$refs['rooms'].querySelector(selector);
        
        if (oldEl) {
          // 销毁房间实例并移除DOM
          RoomItemRenderInstance.destroy({room: origin_room});
          oldEl.remove();
          
          // 额外处理：如果是从展开的文件夹中移除，更新文件夹高度，移除预览图
          if (isFromFolder) {
            const folderEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${origin_out_item.folder_id}"]`);
            if (folderEl) {
              const roomListEl = folderEl.querySelector('.folder-room-list');
              if (roomListEl) {
                // 计算新的文件夹高度并添加过渡动画
                const remainingRooms = origin_out_item.rooms.length;
                if (remainingRooms > 0) {
                  const itemHeight = 54; // 每个房间项的高度
                  const newHeight = itemHeight * remainingRooms + 4 + 'px';
                  
                  // 添加过渡动画
                  roomListEl.style.transition = 'height 0.3s ease';
                  roomListEl.style.height = newHeight;
                }
              }
              const origin_out_item_rooms = origin_out_item.rooms || [];
              if (origin_out_item_rooms.length === 0) {
                const folderInstance = this.folderInstances.get(origin_out_item.folder_id);
                folderInstance?.destroy({folder_id: origin_out_item.folder_id});
                this.folderInstances.delete(origin_out_item.folder_id);
                folderEl.remove();
              }
            }
          }
        }
      }
      
      return oldEl;
    },

    // 创建新元素的HTML
    createElementHtml(origin_out_item, origin_room, isFolder, cur_out_index) {
      let insertHtml = '';
      
      if (isFolder) {
        // 创建文件夹HTML
        const folderRenderInstance = new FolderRenderCtr({
          data: origin_out_item,
          isDefaultOpen: this.open_folders[origin_out_item.folder_id],
          draggable: this.canDragRoom
        });
        // 保存文件夹实例以便后续使用
        this.folderInstances.set(origin_out_item.folder_id, folderRenderInstance);
        insertHtml = folderRenderInstance.render({index: cur_out_index});
      } else {
        // 创建房间项HTML
        insertHtml = RoomItemRenderInstance.render({
          room: origin_room,
          draggable: this.canDragRoom
        });
      }
      
      return insertHtml;
    },

    // 插入到文件夹内目标位置
    insertIntoFolder(target_folder, target_in_index, posAdd, insertHtml, origin_room, isFolder) {
      // 获取目标文件夹DOM
      const folderEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${target_folder.folder_id}"]`);
      if (!folderEl) return;
      
      // 判断文件夹是否展开
      const isFolderOpen = this.isFolderOpen(target_folder.folder_id);
      
      if (isFolderOpen) {
        // ===== 文件夹已展开情况 =====
        // 获取文件夹内的房间列表容器
        const roomListEl = folderEl.querySelector('.folder-room-list');
        if (!roomListEl) return;
        
        // 获取当前文件夹内所有房间项
        const roomElements = Array.from(roomListEl.querySelectorAll('.cpt-shortcut-block-wrapper'));
        let inserted = false;
        
        // 确定插入位置
        if (roomElements.length > 0) {
          // 计算实际插入索引（考虑拖拽方向）
          const insertIndex = Math.min(target_in_index + posAdd, roomElements.length);
          
          if (insertIndex < roomElements.length) {
            // 在指定房间前插入
            const targetRoomEl = roomElements[insertIndex];
            targetRoomEl.insertAdjacentHTML('beforebegin', insertHtml);
            inserted = true;
          } else {
            // 追加到最后一个房间后
            const targetRoomEl = roomElements[roomElements.length - 1];
            targetRoomEl.insertAdjacentHTML('afterend', insertHtml);
            inserted = true;
          }
        }
        
        // 如果文件夹内没有房间项或插入失败，直接追加到列表末尾
        if (!inserted) {
          roomListEl.insertAdjacentHTML('beforeend', insertHtml);
        }
        
        // 初始化新插入元素的事件
        if (!isFolder) {
          RoomItemRenderInstance.initEvents({room: origin_room});
        }
        
        // 更新文件夹高度
        this.updateFolderHeight(target_folder);
      }
      // 文件夹未展开情况下，无需插入DOM，只需更新文件夹头像即可(由上层调用updateFolderAvatars方法)
    },

    // 插入到顶层目标位置
    insertIntoTopLevel(origin_folder, insertHtml, isFolder, origin_out_item, origin_room) {
      // 找到插入位置的前后参考元素
      const dragged_index = this.folders.indexOf(origin_folder);
      const drag_prev_item = this.folders[dragged_index - 1];
      const drag_next_item = this.folders[dragged_index + 1];

      let inserted = false;
      
      // 优先策略1：在前一个元素之后插入
      if (drag_prev_item) {
        const drag_prev_item_dom = this.getFolderRoomDom(drag_prev_item);
        if (drag_prev_item_dom) {
          drag_prev_item_dom.insertAdjacentHTML('afterend', insertHtml);
          inserted = true;
        }
      } 
      
      // 优先策略2：如果没有前一个元素或插入失败，在后一个元素之前插入
      if (!inserted && drag_next_item) { 
        const drag_next_item_dom = this.getFolderRoomDom(drag_next_item);
        if (drag_next_item_dom) {
          drag_next_item_dom.insertAdjacentHTML('beforebegin', insertHtml);
          inserted = true;
        }
      }
      
      // 兜底策略：如果没有相邻元素或插入失败，追加到容器末尾
      if (!inserted) {
        this.$refs['rooms'].insertAdjacentHTML('beforeend', insertHtml);
      }
      
      // 初始化新插入元素的事件
      if (isFolder) {
        const folderRenderInstance = this.folderInstances.get(origin_out_item.folder_id);
        folderRenderInstance?.initEvents();
      } else {
        RoomItemRenderInstance.initEvents({room: origin_room});
      }
    },
    // 获取文件夹或房间的DOM元素
    getFolderRoomDom(item) {
      if (!this.$refs['rooms']) return null;
      
      // 如果是文件夹
      if (item.folder_id && item.folder_id !== '0') {
        return this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${item.folder_id}"]`);
      } 
      // 如果是单个房间
      else if (item.room_id) {
        return this.$refs['rooms'].querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${item.room_id}"]`);
      }
      // 如果是包含房间的对象
      else if (item.rooms && item.rooms.length > 0) {
        const firstRoom = item.rooms[0];
        return this.$refs['rooms'].querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${firstRoom.room_id}"]`);
      }
      
      return null;
    },

    // 更新文件夹高度
    updateFolderHeight(folder) {
      const folderEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${folder.folder_id}"]`);
      if (!folderEl) return;
      
      const roomListEl = folderEl.querySelector('.folder-room-list');
      if (!roomListEl) return;
      
      const itemHeight = 54; // 每个房间项的高度
      const roomCount = folder.rooms.length;
      
      // 设置过渡效果并更新高度
      roomListEl.style.transition = 'height 0.3s ease';
      roomListEl.style.height = itemHeight * roomCount + 4 + 'px';
    },

    // 更新文件夹头像显示
    updateFolderAvatars(folder) {
      // 获取文件夹DOM和实例
      const folderEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${folder.folder_id}"]`);
      if (!folderEl) return;
      
      const folderInstance = this.folderInstances.get(folder.folder_id);
      if (!folderInstance) return;
      
      // 1. 更新头像显示
      const avatarContainer = folderEl.querySelector('.folder-guild-wrapper .shortcut-block');
      if (avatarContainer) {
        UpdateHandler.updateFolderAvatar(folderEl, folderInstance, folder);
      }
      
      // 2. 更新未读消息和状态图标
      const redNumContainer = folderEl.querySelector('.folder-guid-outer');
      if (redNumContainer) {
        // 清除旧的提示元素
        const oldRedElement = redNumContainer.querySelector('.red-num-outer, .red-point');
        const oldIconElement = redNumContainer.querySelector('.folder-speak');
        
        if (oldRedElement) oldRedElement.remove();
        if (oldIconElement) oldIconElement.remove();
        
        // 重新渲染状态图标
        if (folderInstance.renderRoomStatus) {
          const newStatusHTML = folderInstance.renderRoomStatus();
          if (newStatusHTML) {
            redNumContainer.insertAdjacentHTML('beforeend', newStatusHTML);
          }
        }
      }
    },

    // 检查文件夹是否展开
    isFolderOpen(folderId) {
      // 先检查DOM状态
      const folderEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${folderId}"]`);
      if (folderEl) {
        return folderEl.classList.contains('open');
      }
      
      // 回退到data状态
      return !!this.open_folders[folderId];
    },
    
    // 拖拽房间创建文件夹
    async createFolder(cur_ids, origin_ids) {
      // ===== 第一步：创建新文件夹 =====
      let res = await createRoomFolder();
      if (res.data.status === "ok") {
        let folder = res.data.result.folder;
        
        // ===== 第二步：获取源和目标元素信息 =====
        let { out_index: cur_index } = this.findFolderItem(cur_ids);
        let {
          out_index: origin_out_index,
          out_item: origin_out_item,
          in_index: origin_in_index,
          in_item: origin_in_item,
        } = this.findFolderItem(origin_ids);
        
        // 需要记录源元素DOM以便后续移除
        const originRoom = origin_in_item || origin_out_item.rooms[0];
        
        // ===== 第三步：更新数据结构 =====
        // 1. 将当前房间更新为文件夹并添加拖拽的房间
        this.folders[cur_index] = {
          ...this.folders[cur_index],
          ...folder,
        };
        this.folders[cur_index].rooms.push(originRoom);
        
        // 2. 从源位置移除拖拽的房间
        if (origin_in_index !== undefined) {
          origin_out_item.rooms.splice(origin_in_index, 1);
          const folderInstance = this.folderInstances.get(origin_out_item.folder_id);
          folderInstance?.updateFolderNameTooltip(origin_out_item);
        }
        if (
          origin_in_index === undefined ||
          origin_out_item.rooms.length === 0
        ) {
          this.folders.splice(origin_out_index, 1);
        }
        
        // ===== 第四步：DOM操作 =====
        // 1. 移除两个源房间的DOM
        const targetRoom = this.folders[cur_index]?.rooms[0]; // 第一个房间是被拖入的目标
        const isFromFolder = origin_in_item && origin_out_item.folder_id && origin_out_item.folder_id !== '0';
        
        // 移除源DOM元素
        this.removeSourceDom(origin_out_item, originRoom, false, isFromFolder);
        
        // 移除目标DOM元素（将变成文件夹的房间）
        const targetEl = this.$refs['rooms'].querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${targetRoom?.room_id}"]`);
        if (targetEl) {
          RoomItemRenderInstance.destroy({room: targetRoom});
          targetEl.remove();
        }
        
        // 2. 创建新文件夹DOM并插入
        const folderRenderInstance = new FolderRenderCtr({
          data: this.folders[cur_index],
          isDefaultOpen: false, // 新创建的文件夹默认展开
          draggable: this.canDragRoom
        });
        this.folderInstances.set(folder.folder_id, folderRenderInstance);
        
        // 渲染文件夹HTML
        const folderHtml = folderRenderInstance.render({index: cur_index});
        
        // 插入到目标位置
        const prevFolder = this.folders[cur_index - 1];
        const nextFolder = this.folders[cur_index + 1];
        let inserted = false;
        
        if (prevFolder) {
          const prevEl = this.getFolderRoomDom(prevFolder);
          if (prevEl) {
            prevEl.insertAdjacentHTML('afterend', folderHtml);
            inserted = true;
          }
        }
        
        if (!inserted && nextFolder) {
          const nextEl = this.getFolderRoomDom(nextFolder);
          if (nextEl) {
            nextEl.insertAdjacentHTML('beforebegin', folderHtml);
            inserted = true;
          }
        }
        
        if (!inserted) {
          this.$refs['rooms'].insertAdjacentHTML('beforeend', folderHtml);
        }
        
        // 3. 初始化文件夹事件
        folderRenderInstance.initEvents();
        
        // 4. 更新源文件夹头像（如果从文件夹中拖出）
        if (isFromFolder) {
          this.updateFolderAvatars(origin_out_item);
        }
        
        // ===== 第五步：保存排序并更新数据 =====
        // this.open_folders[folder.folder_id] = true; // 记录新文件夹为展开状态
        this.sendFolderSort();
      }
    },
    
    // 拖拽房间进入文件夹
    InFolder(cur_ids, origin_ids) {
      // ===== 第一步：获取源元素信息 =====
      let {
        out_index: origin_out_index,
        out_item: origin_out_item,
        in_index: origin_in_index,
        in_item: origin_in_item,
      } = this.findFolderItem(origin_ids);

      // 判断拖拽类型
      const isFolder = origin_out_item.folder_id && origin_out_item.folder_id !== '0' && !origin_in_item;
      const isFromFolder = origin_in_item && origin_out_item.folder_id && origin_out_item.folder_id !== '0';
      const originRoom = origin_in_item || origin_out_item.rooms?.[0];
      
      // ===== 第二步：从数据结构中删除源元素 =====
      if (origin_in_item) {
        // 是文件夹内房间
        origin_out_item.rooms.splice(origin_in_index, 1);
        const folderInstance = this.folderInstances.get(origin_out_item.folder_id);
        folderInstance?.updateFolderNameTooltip(origin_out_item);
      } else {
        // 是文件夹或外层房间
        this.folders.splice(origin_out_index, 1);
      }

      // ===== 第三步：将元素添加到目标文件夹 =====
      // 获取目标文件夹
      let { 
        out_item: cur_out_item,
        out_index: cur_out_index 
      } = this.findFolderItem(cur_ids);
      
      // 将房间加入到文件夹数据
      cur_out_item.rooms.push(originRoom);
      const folderInstance = this.folderInstances.get(cur_out_item.folder_id);
      folderInstance?.updateFolderNameTooltip(cur_out_item);
      
      // ===== 第四步：DOM操作 =====
      // 1. 移除源元素DOM
      this.removeSourceDom(origin_out_item, originRoom, isFolder, isFromFolder);
      
      // 2. 判断目标文件夹是否展开
      const isFolderOpen = this.isFolderOpen(cur_out_item.folder_id);
      
      if (isFolderOpen) {
        // 如果文件夹已展开，需要在DOM中添加新元素
        const folderEl = this.$refs['rooms'].querySelector(`.cpt-folder-wrapper[data-folder-id="${cur_out_item.folder_id}"]`);
        if (folderEl) {
          const roomListEl = folderEl.querySelector('.folder-room-list');
          if (roomListEl) {
            // 创建新房间元素
            const roomHtml = RoomItemRenderInstance.render({
              room: originRoom,
              folder_id: cur_out_item.folder_id, 
              draggable: this.canDragRoom
            });
            
            // 添加到文件夹末尾
            roomListEl.insertAdjacentHTML('beforeend', roomHtml);
            
            // 初始化新房间的事件
            const newRoomEl = roomListEl.querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${originRoom.room_id}"]`);
            if (newRoomEl) {
              RoomItemRenderInstance.initEvents({room: originRoom}, newRoomEl);
            }
            
            // 更新文件夹高度
            this.updateFolderHeight(cur_out_item);
          }
        }
      } else {
        // 如果文件夹未展开，只需更新文件夹头像
        this.updateFolderAvatars(cur_out_item);
      }
      
      // 3. 如果源是展开的文件夹中的房间，更新源文件夹头像显示
      if (isFromFolder) {
        this.updateFolderAvatars(origin_out_item);
      }
      
      // ===== 第五步：保存排序并更新数据 =====
      this.sendFolderSort();
    },
    // 红点更新的时候，也更新房间和文件夹的红点
    updateUnreadStateCache(room_id) {
      if (room_id) {
        const folder = this.folders.find(v => v.rooms && v.rooms?.some(v => v.room_id === room_id));
        if (!folder) return
        if (folder && folder.folder_id != '0') {
          const folderInstance = this.folderInstances.get(folder.folder_id);
          updateHandler.updateRedPoint(folder, folderInstance);
        } else {
          const room = folder?.rooms?.find(v => v.room_id === room_id);
          if (room) {
            updateHandler.updateRoomRedPoint(room.room_id);
          }
        }
      } else {
        this.folders.forEach(folder => {
          const folderInstance = this.folderInstances.get(folder.folder_id);
          updateHandler.updateRedPoint(folder, folderInstance);
        })
      }
    },

    // 清除空文件夹并提交接口
    sendFolderSort() {
      this.folders = this.folders.filter(
        (folder) => folder.rooms && folder.rooms.length > 0
      );

      this.folders.forEach(folder => this.updateDomHeight(folder))
      this._handleShortCutsScroll()
      let folderLevelList = this.folders.map((folder, index) => {
        return {
          folder_id: folder.folder_id,
          level: this.folders.length - index,
          rooms: folder.rooms.map((room, i) => {
            return {
              room_id: room.room_id,
              level_in_folder: folder.rooms.length - i,
            };
          }),
        };
      });
      sortSideFolders(
        {},
        {
          folders: JSON.stringify(folderLevelList),
        }
      )
    },
    // 根据out_id和in_id获取对应的房间/文件夹信息
    findFolderItem(ids) {
      let { out_id, in_id } = ids;
      if (!out_id) {
        return null;
      }
      let out_index = this.folders.findIndex(
        (v) =>
          v.folder_id == out_id ||
          (v.folder_id == "0" && v.rooms[0].room_id === out_id)
      );
      let out_item = this.folders[out_index];
      if (!in_id) {
        return {
          out_index,
          out_item,
        };
      } else {
        let in_index = out_item.rooms.findIndex((v) => v.room_id == in_id);
        let in_item = out_item.rooms[in_index];
        return {
          out_index,
          out_item,
          in_index,
          in_item,
        };
      }
    },
    // 将频道移动至顶部
    setRoomTop(id) {
      if (!this.folders[0]) return;

      let top_id =
        this.folders[0].folder_id == "0"
          ? this.folders[0].rooms[0].room_id
          : this.folders[0].folder_id;
      // 启动到首位就是把当前id的房间移动到第一个item的上方
      this.moveFolder(
        {
          out_id: top_id,
        },
        {
          out_id: id,
        },
        "up"
      );
    },
    // 获取邀请码监听
    getInviteCode(data, cb, available) {
      data = data || {};
      let { channel_id, room_id, source, is_guidance } = data;
      let params = {
        user_id: this.user_info.user_id,
        room_id: room_id || this.cur_room_data.room_id,
        channel_id: channel_id,
        available,
      };
      // INFO: source 用于埋点检测
      if(source) params.source = source
      if(is_guidance) params.is_guidance = is_guidance
      getChannelInviteCode(params).then((res) => {
        if (res.data.status === "ok") {
          cb && cb(res.data.result.invite_code);
        }
      });
    },

    handleWindowResize: throttle(function (e) {
      const scrollEl = this.$parent.$refs["shortcuts-scroller"]
      const scrollEvent = new Event("scroll")
      if(scrollEl) scrollEl.dispatchEvent(scrollEvent);
    }, 100),

    async joinPublicRoom(public_id) {
      const successCb = (res, status) => {
        if (this.cur_room_data.public_id === public_id) {
          this.SET_CUR_ROOM_WHOLE_DATA_KEY("my_room_info", {
            ...this.cur_room_whole_data.my_room_info,
            is_visitor: false,
          });
        }
        this.getSideFolders();
        EventBus.$emit("Update_room_view", () => {
          this.$permission.clearPermissionCache(this.$route.params.room_id);
        });
        EventBus.$emit("Refresh_Member_List");
        this.$permission.clearPermissionCache(this.$route.params.room_id);
        if (status?.status === 'APPLIED') {
          this.$toast.success("已发送申请");
        } else if (status?.status === 'VERIFIED') {
          this.$toast.success("加入成功");
        } else {
          this.$toast.success("加入成功");
        }
      };

      handleEnterRoom(public_id, ENTER_BY_INVITE_CODE_TYPES["public"], {
        successCb,
        enterWay: this.discover_enter_way,
      });
    },
    // 更新房间信息
    handleUpdateRoomInfo(data) {
      let { room } = data.data;
      if (!room) return;

      if (room.room_id === this.cur_channel_data.room_id) {
        this.SET_CUR_CHANNEL_DATA({
          ...this.cur_channel_data,
          room_avatar: room.room_avatar,
          room_name: room.room_name,
        });
      }
      let _room_list = JSON.parse(JSON.stringify(this.room_list)),
        _room = _room_list.find((v) => v.room_id === room.room_id);
      let isUpdate = false;
      if (_room) {
        isUpdate = (_room.room_avatar !== room.room_avatar || _room.room_name !== room.room_name);
        _room.room_avatar = room.room_avatar;
        _room.room_name = room.room_name;
      }
      this.SET_ROOM_LIST(_room_list);
      if (isUpdate) {
        const oldEl = this.$refs['rooms'].querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room.room_id}"]`);
        RoomItemRenderInstance.destroy({room: _room})
        const newHtml = RoomItemRenderInstance.render({
          room: _room,
          // index: oldEl.dataset.index,
          draggable: this.canDragRoom
        })
        if (oldEl) {
          oldEl.outerHTML = newHtml;
        }
        RoomItemRenderInstance.initEvents({room: _room})
      }

      for (let folder of this.folders) {
        if (folder.rooms) {
          for (let r of folder.rooms) {
            if (r.room_id === room.room_id) {
              r.room_avatar = room.room_avatar;
              r.room_name = room.room_name;
              return
            }
          }
        }
      }
      
    },
    handleRoomDelete(data) {
      let d = data.data;
      if (d.room_id) {
        this.getSideFolders();
      }
    },
    destroyRoom(room_id, folder_id) {
      if (!room_id) return;
      if (folder_id && folder_id != '0') {
        const folder_instance = this.folderInstances.get(folder_id);
        if (folder_instance) {
          folder_instance.destroy({room_id, folder_id});
        }
      } else {
        RoomItemRenderInstance.destroy({room_id});
      }
      UpdateHandler.deleteRoom(room_id, folder_id)
    },
    delRoomFromList(data) {
      const room_id = data.data.room_id;
      const folder = this.folders.find(v => v.rooms?.some(r => r.room_id === room_id));
      this.destroyRoom(room_id, folder?.folder_id);
      
      this.getSideFolders();
    },
    // 进入默认房间，如果当前在频道内，进入频道所在房间; 如果房间列表不为空，进入第一个房间；其他情况弹出创建房间弹窗
    enterDefaultRoom() {
      if (this.cur_channel_data.room_id) {
        EventBus.$jump({
          room_id: this.cur_channel_data.room_id,
        });
      } else if (this.room_list.length > 0) {
        EventBus.$jump({
          room_id: this.room_list[0].room_id,
        });
      } else {
        EventBus.$emit("Show_Create_Room_dialog");
      }
    },
    updateFolderData(data) {
      let index = this.folders.findIndex((v) => v.folder_id === data.folder_id);
      if (index >= 0) {
        this.$set(this.folders, index, {
          ...this.folders[index],
          ...data,
        });
      }
      const folderInstance = this.folderInstances.get(data.folder_id);
      const folderData = this.folders.find(v => v.folder_id === data.folder_id);
      if (folderInstance && folderData) {
        folderInstance.updateFolderNameTooltip(folderData);
        folderInstance.updateFolderBgColor(folderData);
      }
    },
    // 房间列表全量更新
    handleUpdateRoomList(data) {
      data.data.folders.forEach(folder => {
        folder.rooms.forEach(room => {
          room.folder_id = folder.folder_id;
        });
      });
      const changed = this.compareFolderChanges(
        this.folders,
        data.data.folders
      );
      this.folders = data.data.folders;
      let flat_room_list = [];
      
      this.folders.forEach((folder) => {
        if (folder.rooms?.length) {
          folder.rooms.forEach((room) => {
            room.folder_id = folder.folder_id;
          });
          flat_room_list = [...flat_room_list, ...folder.rooms];
        }
      });

      this.SET_ROOM_LIST(flat_room_list);
      // 如果当前所在语音房间不在新的房间列表里，退出语音
      if (this.cur_channel_data.room_id) {
        if (!flat_room_list.some(({ room_id }) => room_id === this.cur_channel_data.room_id)) {
          EventBus.$emit("Channel_Access:exitChannel");
          if (this.$route.name === "room" && this.$route.params.room_id == this.cur_channel_data.room_id) {
            this.$router.push({ name: "home" });
          }
        }
      }
      this.handleChangedFolders(changed)
    },
    handleChangedFolders(changed) {
      const { removedRooms, addedRooms } = changed
      // 删除被移除的房间
      removedRooms.forEach(room => {
        this.destroyRoom(room.room_id, room.folder_id);
        Cache.delRoomCache(room.room_id);
        this.$permission.clearPermissionCache(room.room_id);
      })
      // 插入新增房间
      let html = '';
      addedRooms.forEach((room, index) => {
        this.$permission.clearPermissionCache(room.room_id);
        if (this.cur_room_data.room_id === room.room_id) {
          EventBus.$emit("Update_room_view");
          if (this.channel_data.channel_id) {
            EventBus.$emit("Update_Cur_Channel_IM");
          }
        }
        html += RoomItemRenderInstance.render({
          room,
          index: index,
          draggable: this.canDragRoom
        })
      });
      const roomsEL = this.$refs['rooms']
      if (roomsEL) {
        // 插入到最前面
        roomsEL.insertAdjacentHTML('afterbegin', html);
      }
      // 初始化新增房间的事件
      addedRooms.forEach(room => {
        RoomItemRenderInstance.initEvents({room}, this.$refs['rooms'].querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room.room_id}"]`))
      })
    },
    compareFolderChanges(old_folders, new_folders) {
      // 使用 Map 存储房间 ID 到房间对象的映射
      const oldRoomMap = new Map();
      const newRoomMap = new Map();
      
      // 一次遍历收集所有房间
      old_folders.forEach(folder => 
        folder.rooms?.forEach(room => 
          oldRoomMap.set(room.room_id, room)
        )
      );
      
      new_folders.forEach(folder => 
        folder.rooms?.forEach(room => 
          newRoomMap.set(room.room_id, room)
        )
      );
      
      const removedRooms = [];
      const addedRooms = [];
      
      // 找出被移除的房间
      for (const [roomId, room] of oldRoomMap) {
        if (!newRoomMap.has(roomId)) {
          removedRooms.push(room);
        }
      }
      
      // 找出新增的房间
      for (const [roomId, room] of newRoomMap) {
        if (!oldRoomMap.has(roomId)) {
          addedRooms.push(room);
        }
      }
      
      return { removedRooms, addedRooms };
    },
    addRoomStateNumber(room_Id, types, isAdd = 0, target_user_info) {
      if (!room_Id || !types) return;
      const target_user_id = target_user_info ? target_user_info.user_id : this.user_info.user_id;
      target_user_info = target_user_info ? target_user_info : this.user_info;
      target_user_info = deepCopy(target_user_info);
      let _room_list = [];
      this.folders.forEach((v) => {
        if (v.rooms) {
          _room_list = [..._room_list, ...v.rooms];
        }
      });
      let room = _room_list.find((v) => v.room_id === room_Id);
      if (room) {
        if (typeof types === "string") {
          types = [types];
        }
        types.forEach((type) => {
          switch (type) {
            case "audio":
              if (!room.members) {
                this.$set(room, 'members', []);
              }
              if (!room.audio_count) {
                this.$set(room, 'audio_count', 0);
              }
              if (isAdd) {
                if (!room.members?.find((v) => v.user_id == target_user_id)) {
                  room.members.push(target_user_info);
                  room.audio_count += 1;
                }
              } else {
                let index = room.members?.findIndex((v) => v.user_id == target_user_id);
                if (index >= 0) {
                  room.members.splice(index, 1);
                  room.audio_count -= 1;
                }
              }
              if (room.audio_count <= 0) {
                room.audio_count = 0;
              }
              break;
            case "bgm":
              if (!room.audio_share_members) {
                this.$set(room, 'audio_share_members', []);
              }
              if (isAdd) {
                if (!room.audio_share_members?.find((v) => v.user_id == target_user_id)) {
                  room.audio_share_members.push(target_user_info);
                }
              } else {
                room.audio_share_members = room.audio_share_members?.filter((v) => v.user_id != target_user_id) || [];
              }
              break;
            case "screen":
              if (!room.screen_share_members) {
                this.$set(room, 'screen_share_members', []);
              }
              if (isAdd) {
                if (!room.screen_share_members?.find((v) => v.user_id == target_user_id)) {
                  room.screen_share_members.push(target_user_info);
                }
              } else {
                room.screen_share_members = room.screen_share_members?.filter((v) => v.user_id != target_user_id) || [];
              }
              break;
          }
        });
        updateHandler.updateRoomAudioIcon(room)
      }
    },
    handlePushBack() {
      this.$router.push({
        name: "invite",
        params: {
          invite_code: this.temp_private_invite?.inviteCode,
        },
      });
      this.SET_TEMP_PRIVATE_INVITE(null);
    },
    // 左侧侧边栏滚动监听
    _handleShortCutsScroll(e) {
      if (!e) {
        e = { target: this.$parent.$refs["shortcuts-scroller"] };
      }
      if (!e.target) return;

      const { scrollTop, clientHeight } = e.target;

      let currentHeight = 0,
        startIndex = -1,
        endIndex = -1;

      for (let i = 0; i < this.folders.length; i++) {
        const folder = this.folders[i];
        const domHeight = folder.domHeight; // 累加 domHeight 数组的总高度

        // 判断是否进入可视区域
        if (
          currentHeight + domHeight + this.scrollerOffsetTop >
          scrollTop - VIRTUAL_ROOMSHORTCUTS_SCROLLER_CONFIG.TOP_THRESHOLD &&
          startIndex === -1
        ) {
          startIndex = i;
        }

        // 判断是否超出可视区域
        if (
          currentHeight + this.scrollerOffsetTop >
          scrollTop +
          clientHeight +
          VIRTUAL_ROOMSHORTCUTS_SCROLLER_CONFIG.BOTTOM_THRESHOLD
        ) {
          endIndex = i + 1;
        }
        currentHeight = currentHeight + domHeight;

        if (endIndex !== -1) {
          this.show_folders_index = [startIndex, endIndex];
          break;
        } else if (i === this.folders.length - 1) {
          this.show_folders_index = [startIndex, i];
        }
      }
    },
    handleShortCutsScroll: throttle(function (e) {
      this._handleShortCutsScroll(e)
    }, 100),
    changeIsOpen(folder, v) {
      this.open_folders[folder.folder_id] = v;
      this.updateDomHeight(folder);
      setTimeout(() => {
        this.updateScrollerOffsetTop()
      }, 100)
    },
    updateDomHeight(folder) {
      this.$set(
        folder,
        "domHeight",
        calRoomShortCutHeihgt(
          folder.folder_id === 0 ? "room" : "folder",
          folder.rooms?.length,
          this.open_folders[folder.folder_id]
        )
      );
    },
    updateScrollerOffsetTop() {
      this.scrollerOffsetTop = this.$el.offsetTop + CHAT_ICON_HEIGHT;
      this.handleShortCutsScroll();
    },
    handleOpenSort(active) {
      this.sortBtnActive = active
    },
    initTrigger() {
      this.roomSortPopoverTrigger = this.$refs['roomSortPopoverTrigger']
    },
    handleChangeSort(value) {
      if (value === this.user_account_settings?.folder_sort) return;
      const obj = {
        folder_sort: value
      }
      this.SET_USER_ACCOUNT_SETTINGS(obj)
      updateAccountSetting({}, {
        setting: 'folder_sort',
        value,
      })
      
      this.renderFolderList()
    },
    ...mapActions(["SET_ROOM_LIST"]),
    ...mapMutations([
      "SET_USER_INFO",
      "SET_WS_ID",
      "SET_BLACKLIST",
      "SET_INVISIBLELIST",
      "SET_ONLINESTATE",
      "SET_CUR_CHANNEL_DATA",
      "SET_ENTER_DEFAULT_CHANNEL_RESULT",
      "SET_TEMP_PRIVATE_INVITE",
      "SET_NEW_MEMBER_GUIDER_CONFIG",
      "SET_CUR_ROOM_WHOLE_DATA_KEY",
      "SET_USER_ACCOUNT_SETTINGS",
    ]),
  },
};
</script>
<style lang="scss">
.cpt-room-container {
  .temp-room {
    border-bottom: 1px solid $d-op-2;
    margin-bottom: 6px;
    padding-bottom: 12px;
  }

  .placeholder-room {
    height: 54px;
  }

  .placeholder-folder.open {
    padding: 54px 0 2px;
  }
  .room-sort-btn {
    &>.iconfont {
      font-size: 14px;
    }
  }
}
.room-sort-setting-popover {
  .room-sort-setting-item {
    display: flex;
    height: 32px;
    padding: 5px 8px;
    align-items: center;
    justify-content: space-between;
    align-self: stretch;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background: $d-bd-fl;
      .room-sort-setting-item-label {
        color: $ct-wh-0 !important;
      }
    }
    &.active {
      .room-sort-setting-item-label {
        color: $d-tx-1;
        font-weight: 700;
      }
      .radio {
        border: 2px solid $d-bd-tx !important;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          width: 8px;
          height: 8px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: $d-bd-tx;
          border-radius: 50%;
        }
      }
    }
    .room-sort-setting-item-label {
      color: $d-tx-2;
      font-size: 14px;
    }
    .radio {
      width: 16px;
      height: 16px;
      border: 2px solid $d-op-3;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
}
</style>
<style lang="scss">
.cpt-shortcut-block-wrapper {
  &.up {
    border-top: 3px solid $d-bd-tx;
    padding-top: 4.5px;
    margin-top: -1.5px;
  }
  &.down {
    border-bottom: 3px solid $d-bd-tx;
    padding-bottom: 4.5px;
    margin-bottom: -1.5px;
  }
  &.virtual-folder {
    position: relative;
    &::after {
      content: '';
      height: 8px;
      width: 8px;
      border-radius: 50%;
      position: absolute;
      left: -9px;
      top: 50%;
      transform: translateY(-50%);
      background-color: $d-bd-tx;
    }
    .shortcut-block {
      animation: shake .2s linear infinite;
      padding: 4px;
      align-items: stretch;
      justify-content: space-between;
      background-color: $d-op-2;
      position: relative;
      .cpt-chat-room-avatar, img {
        width: 16px!important;
        height: 16px!important;
        background: transparent !important;
        border-radius: 3px !important;
        span {
          font-size: 12px;
          transform: scale(.5);
          transform-origin: center center;
        }
      }
    }
  }
}
.clip-name-icon {
  color: $d-op-5;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.22px;
}

.cpt-folder-wrapper {
  &.mini {
    &.has-red-point {
      .folder-guid-outer::after {
        content: '';
        width: 12px;
        height: 12px;
        background-color: $d-er-fl;
        border-radius: 50%;
        border: 2px solid $d-fl-nv;
        position: absolute;
        top: -2px;
        right: -2px;
      }
    }
    .folder-bg {
      position: absolute;
      top: 0;
      left: 8px;
      right: 8px;
      height: 100%;
      border-radius: 25px;
      background: $d-op-2;
      opacity: 0;
      transition: opacity 0.2s;
    }
    .folder-guild {
      .folder-guild-contain {
        width: 42px;
        height: 42px;
        margin: 0 auto;
        border-radius: 50%;
        overflow: hidden;
        .folder-guild-wrapper {
          transition: all 0.2s;
          background-color: $d-op-2;

          .mp-folder-item {
            position: relative;
            width: 42px;
            height: 42px;
            padding: 8px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: stretch;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .folder-icon {
            i {
              color: #eac645;
            }
          }
        }
      }
    }
    .folder-mp-list {
      width: 100%;
      // margin: -6px auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      transition: height 0.2s;
      position: relative;
    }
  }

  .folder-speak {
    border: 2px solid $d-fl-nv;
    &::before {
      width: 14px;
      height: 14px;
      font-size: 14px;
      transform: translateY(0.5px);
    }
    &.active {
      background: $d-bd-fl;
      color: $ct-wh-0;
    }
  }

  &.active {
    &::before {
      content: "";
      width: 46px;
      height: 46px;
      border: 2px solid $d-bd-fl;
      border-radius: 12px;
      position: absolute;
      left: 8px;
      top: 2px;
      transition: transform 0.2s;
    }
  }
  &.up, &.down {
    &::after {
      content: "";
      height: 3px;
      position: absolute;
      left: 12px;
      right: 12px;
      background-color: $d-bd-tx;
    }
  }
  &.virtual-folder {
    .folder-guid-outer {
      animation: shake 0.2s linear infinite;
    }
    &::after {
      content: "";
      height: 8px;
      width: 8px;
      border-radius: 50%;
      position: absolute;
      left: 2px;
      top: 50%;
      transform: translateY(-50%);
      background-color: $d-bd-tx;
    }
  }
  &.up::after {
    top: -1px;
  }
  &.down::after {
    bottom: -1px;
  }

  &.scale-up {
    &::before,
    .folder-guid-outer {
      transform: scale(1.1);
    }
  }

  &.open {
    .folder-bg {
      opacity: 1;
    }
    .folder-guild-wrapper {
      background-color: $d-op-2 !important;
      transform: translateY(-48px);
    }
    .folder-guild-contain {
      transform: scale(1) !important;
    }
  }

  .folder-bg {
    height: 100%;
    position: absolute;
    top: 0;
    left: 8px;
    right: 8px;
    opacity: 0;
    background: $d-op-2;
    transition: opacity 0.2s;
    border-radius: 12px;
  }
  .folder-guild {
    width: 42px;
    padding: 6px 0;
    margin: 0 auto;
    position: relative;
    .folder-guild-contain {
      width: 42px;
      height: 42px;
      margin: 0 auto;
      border-radius: 8px;
      overflow: hidden;
      .folder-guild-wrapper {
        transition: all 0.2s;
        background-color: $d-op-2;

        .folder-items {
          width: 42px;
          height: 42px;
          padding: 4px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: stretch;

          .cpt-chat-room-avatar {
            span {
              transform: scale(0.7);
              transform-origin: center center;
              color: $d-op-5;
              line-height: 16px;
            }
          }
        }
        .folder-icon {
          width: 42px;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 6px;
          i {
            font-size: 20px;
            width: 20px;
            height: 20px;
            color: $d-op-5;
          }
        }
      }
    }
  }
  .folder-room-list {
    width: 100%;
    // margin: -6px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    transition: height 0.2s;
    position: relative;
  }
}
</style>